module.exports = __webpack_public_path__ + "media/icon/icon-countertops-gray-b61ee0cf.svg";